/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     NAME: section.tsx
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 STANDARD IMPORTS
****************************************************************************************************************************/
import { CSSProperties, FunctionComponent, ReactNode } from 'react';

import Utils from '@/utils';
/***************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
****************************************************************************************************************************/
type SectionProps = {
    id: string,
    children: ReactNode | ReactNode[],
    background?: CSSProperties, 
    className?: string
}
/***************************************************************************************************************************
 CLASSES / FUNCTIONS
****************************************************************************************************************************/
const Section: FunctionComponent<SectionProps> = ({ id, children, background = undefined, className = ""}: SectionProps) => {
    return (
        <section
        key={Utils.getUniqueId("section")}
        id={id}
        className={`w-full px-5 py-10 ${className}`}
        style={background}>
            <div
            className="w-full mx-auto max-w-screen-xl">
                {children}
            </div>
        </section>
    );
};

export default Section;